export const ACCESS_TOKEN = 'ACCESS-TOKEN'
export const SEEKER_INFO = 'SEEKER_INFO'
export const NAME = 'NAME'
